export const AUTH_SUCCESS = "auth_success";
export const AUTH_ERROR = "auth_error";
export const AUTH_REQUEST = "auth_request";
export const AUTOLEIE_GET_INSURANCES_SUCCESS = "autoleie_get_insurances_success";
export const AUTH_REGISTER = "auth_register";
export const AUTH_REGISTER_SUCCESS = "auth_register_success";
export const AUTOLEIE_GET_INSURANCES_FAIL = "autoleie_get_insurances_fail";
export const AUTH_GET_PROFILE_SUCCESS = "auth_get_profile_success";
export const RENTAL_GET = "rental_get";
export const RENTAL_GET_SUCCESS = "rental_get_success";
export const ADMINISTRATION_GET_APPLICATIONS_SUCCESS = "administration_get_apllications_success";
export const AGILE_GET_LOCATIONS_SUCCESS = "agile_get_locations_success";
export const AGILE_GET_QUOTES_SUCCESS = "agile_get_quotes_success";
export const AGILE_POST_BOOKING_SUCCESS = "agile_post_booking_success";
export const AGILE_GET_CARIMAGE_SUCCESS = "agile_get_carimage_success";
export const AGILE_UPDATE_SEAT = "agile_update_seat_selection";
export const AGILE_SET_SEAT = "agile_set_seat_options";
export const AGILE_UPDATE_GEAR = "agile_update_gear_selection";
export const AGILE_SET_GEAR = "agile_set_gear_options";
export const AGILE_UPDATE_FUEL = "agile_update_fuel_selection";
export const AGILE_SET_FUEL = "agile_set_fuel_options";
export const AGILE_UPDATE_CATEGORY = "agile_update_category_selection";
export const AGILE_SET_CATEGORY = "agile_set_category_options";

